import {
    RouteParams, RouteParamsList,
} from 'navigation/types'

export type DefaultMenubarProps = {
    name?: string
    routeParams?: RouteParams
}

export type DefaultMenubarViewProps = DefaultMenubarProps & {
    onClose: () => void
}

export enum ItemDisplayType {
    all = 'all',
    lastItem = 'lastItem',
    middleItems = 'middleItems'
}

export type NestedDefaultMenuBarProps<K extends keyof RouteParamsList> = {
    params: RouteParamsList[K]
    type?: ItemDisplayType
}
